import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { VideoInterface } from 'common/types/entities/VideoInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createVideo(
  parentId: string,
  masterBlockId?: MasterBlockId,
): VideoInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.Video, parentId, masterBlockId),
    url: 'https://youtu.be/f48bbvvDJFQ',
    border: {
      radius: 8,
    },
    controls: true,
  }
}
